module.exports = __webpack_public_path__ + "media/images/woman-profile-2-670b90c6eca86219e83581423eb6980b.jpeg";